module.exports = __webpack_public_path__ + "static/img/deepwater.00e0aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deepwater.png
// module id = lY4d
// module chunks = 1